import React, { useEffect, useState } from 'react';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import '@progress/kendo-theme-default/dist/all.css';
import { UsersService } from '../../services/users.service';
import { CountriesUser, ProgramsUser, Users } from '../../models/users.model';
import { AxiosResponse } from 'axios';
import { PaisesService } from '../../services/paises.service';
import { ProgramasService } from '../../services/programas.service';
import './admin-user.scss';
import { setTimeout } from 'timers';
import { Infra2_User } from '../../models/infradigital/infra2_user.model';
import { NotificationsService } from '../../services/notifications.service';
import { NotificationsFilter } from '../../models/notificationsFilter.model';
import { General } from '../../services/general';
import { NotificationAlert } from '../../models/notifications.model';
import Loading from '../shared/loading/Loading.component';
import ShowCreateCountry from '../shared/Countries/CountriesButton';
import ShowCreateProgram from '../shared/Programs/ProgramsButton';

export default function AdminUser(props: any) {
  // const [valueRol, setRol] = React.useState<Array<any>>([]);
  const usersService = UsersService({ locale: 'en' });
  const notificationsService = NotificationsService({ locale: 'en' });
  const paisesService = PaisesService({ locale: 'en' });
  const programasService = ProgramasService({ locale: 'en' });
  const [items, setItems] = useState<Users[]>([]);
  // const [infraUsers, setInfraUsers] = useState<Infra2_User[]>([]);
  const [paises, setPaises] = useState<CountriesUser[]>([]);
  const [programas, setProgramas] = useState<ProgramsUser[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [successSaved, setSuccessSaved] = useState<boolean>(false);
  // const onRol = (event: MultiSelectChangeEvent) => {
  //   setRol([...event.value]);
  // };

  const onCoun = (event: any, props: any): CountriesUser[] => {
    setSuccessSaved(false);
    setLoading(true);
    setTimeout(() => {
      props.dataItem.countriesUser = event.value;
      props.dataItem.isPendingChange = true;
      setItems(items);
      setLoading(false);
    }, 10);
    return props.dataItem.countriesUser;
  };

  const onChangePrograms = (event: any, props: any) => {
    setSuccessSaved(false);
    setLoading(true);
    setTimeout(() => {
      props.dataItem.programsUser = event.value;
      props.dataItem.isPendingChange = true;
      setItems(items);
      setLoading(false);
    }, 10);
  };

  // const onChangeName = (event: any, props: any) => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     props.dataItem.name = event.target.value;
  //     props.dataItem.isPendingChange = true;
  //     setItems(items);
  //     setLoading(false);
  //   }, 10);
  // };

  // const onChangeUserName = (event: any, props: any) => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     props.dataItem.username = event.target.value;
  //     props.dataItem.isPendingChange = true;
  //     setItems(items);
  //     setLoading(false);
  //   }, 10);
  // };


  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const loadData = () => {
    setLoading(true);
    paisesService.getPaises().then(responsePaises => {
      setPaises(responsePaises.data.map(c => {
        return { countryId: c.oid as number, countryName: c.nombre }
      }));
      programasService.getProgramas().then(responseProgramas => {
        setProgramas(responseProgramas.data.map(p => {
          return { programId: p.oid, programName: p.descripcion }
        }));
        usersService.getInfraDigitalUsersByApp().then((infraResponse: AxiosResponse) => {
          const infraUsers: Infra2_User[] = infraResponse.data;
          // setInfraUsers(infraUsers);
          usersService.getUsers().then((response: AxiosResponse) => {
            let usersInDB: Users[] = response.data;
            infraUsers.forEach((infU: Infra2_User) => {
              const exists = usersInDB.filter(s => s.username.toLowerCase() === infU.Username);
              let roles: string[] = [];
              const filtRoles = infU.Infra2_V_GroupsByUsers?.filter(s => s.IsUserDefaultGroup === false).map(m => m.Name);
              if (filtRoles && filtRoles.length > 0) { }
              roles = filtRoles as string[];
              if (exists.length === 0) {
                const userToAdd: Users = {
                  id: 0,
                  createdAt: infU.CreatedAt,
                  inactive: false,
                  username: infU.Username,
                  name: infU.Name,
                  sub: '',
                  countriesUser: [],
                  programsUser: [],
                  roles: roles,
                  isPendingChange: true,
                  invalidCountry: false,
                  invalidProgram: false,
                };
                usersInDB.push(userToAdd);
              } else {
                exists[0].roles = roles;
                if (!exists[0].programsUser || !exists[0].countriesUser
                  || (exists[0].programsUser && exists[0].programsUser.length === 0)
                  || (exists[0].countriesUser && exists[0].countriesUser.length === 0)) {
                  exists[0].isPendingChange = true;
                }
              }
            });
            setItems(usersInDB);
            setLoading(false);
          })
        })
      })
    });

  }

  const isValidUsers = (items: Users[]): boolean => {
    setLoading(true);
    let invalid = false;
    let itemsClon = items;
    const countriesInvalids =
      items.filter((x: Users) => x.countriesUser === undefined || x.countriesUser.length === 0);
    const programsInvalids =
      items.filter((x) => x.programsUser === undefined || x.programsUser.length === 0);
    if (countriesInvalids.length > 0) {
      countriesInvalids.forEach((x, i) => {
        const itemToInvalidate = items.findIndex((j) => j.id === x.id);
        itemsClon[itemToInvalidate].invalidCountry = true;
      });
      invalid = true;
    }

    if (programsInvalids.length > 0) {
      programsInvalids.forEach((x, i) => {
        const itemToInvalidate = items.findIndex((j) => j.id === x.id);
        itemsClon[itemToInvalidate].invalidProgram = true;
      });
      invalid = true;
    }
    setItems(itemsClon);
    setTimeout(() => {
      setLoading(false);
    }, 50);
    return !invalid;
  };

  const saveUsers = async () => {
    if (!isValidUsers(items)) {
      return;
    }
    await usersService.saveUsers(items);
    const filter: NotificationsFilter = {
      notificationType: General.NotificationType.AssignProgramsAndCountriesUser,
      statusId: 0
    };
    const notifications = await notificationsService.getNotifications(filter);
    if (notifications.data.length > 0) {
      notifications.data.forEach(async (item: NotificationAlert) => {
        item.statusId = 1;
        const findUser = items.filter(s => s.username === item.userNameAssignPrograms);
        if (findUser.length > 0 && findUser[0].countriesUser && findUser[0].countriesUser.length > 0
          && findUser[0].programsUser && findUser[0].programsUser.length > 0) {
          await notificationsService.updateNotification(item)
        }
      });
      props.changeNotifications();

    }
    loadData();
    setSuccessSaved(true);
  }

  // const addUser = () => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     const user: Users = {
  //       createdAt: new Date(),
  //       inactive: false,
  //       username: '',
  //       countriesUser: [],
  //       name: '',
  //       programsUser: [],
  //       sub: '',
  //       id: 0,
  //       isPendingChange: true,
  //       invalidCountry: false,
  //       invalidProgram: false,
  //     };

  //     items.push(user);
  //     setItems(items);
  //     setLoading(false);
  //   }, 100);
  // };

  return (
    <section id="profile">
      {successSaved && (
        <div className="row">
          <div className="container">
            <div className="alert alert-success" role="alert">
              Los cambios fueron guardados satisfactoriamente
            </div>
          </div>
        </div>
      )}
      {items && items.filter((s) => s.isPendingChange === true).length > 0 && (
        <div className="container">
          <div className="row">
            <div className="alert warning-alert" role="alert">
              Tienes cambios pendientes para guardar
            </div>
          </div>
        </div>
      )}
      {loading && (
        <div className="loading-comp">
          <Loading />
        </div>
      )}
      {!loading && (
        <div className="container mt-5">
          <div className="row">
            <div className="col-12">
              <div className="d-flex data-profile flex-column">
                <div className='d-flex justify-content-end mb-3'>
                  <ShowCreateCountry />
                  <ShowCreateProgram />
                </div>
                <Grid style={{ height: '400px' }} data={items}>
                  {/* <GridColumn field="id" title="ID" width="40px" /> */}
                  <GridColumn
                    field="name"
                    title="Nombre"
                    width="250px"
                    editor="text"
                    cell={(props: any) => (
                      <td
                        className={
                          props.dataItem.isPendingChange ? 'pendingChanges' : ''
                        }
                      >
                        <span>{props.dataItem.name}</span>
                        {/* <TextField disabled={true}
                        defaultValue={props.dataItem.name}
                        onChange={(e: any) => { onChangeName(e, props) }}
                      ></TextField> */}
                      </td>
                    )}
                  />
                  <GridColumn
                    field="username"
                    title="Usuario"
                    editor="text"
                    cell={(props: any) => (
                      <td
                        className={
                          props.dataItem.isPendingChange ? 'pendingChanges' : ''
                        }
                      >
                        <span>{props.dataItem.username}</span>
                        {/* <TextField disabled={true}
                        defaultValue={props.dataItem.username}
                        onChange={(e: any) => { onChangeUserName(e, props) }}
                      ></TextField> */}
                      </td>
                    )}
                  />
                  <GridColumn
                    field="roles"
                    title="Rol"
                    cell={(props: any) => (
                      <td
                        className={
                          props.dataItem.isPendingChange ? 'pendingChanges' : ''
                        }
                      >
                        <span>
                          {props.dataItem.roles
                            ? props.dataItem.roles.join(', ')
                            : ''}
                        </span>
                      </td>
                    )}
                  />
                  <GridColumn
                    field="countriesUser"
                    title="País"
                    cell={(props: any) => (
                      <td
                        className={
                          props.dataItem.isPendingChange ? 'pendingChanges' : ''
                        }
                      >
                        <MultiSelect
                          data={paises}
                          textField="countryName"
                          dataItemKey="countryId"
                          filterable={true}
                          onChange={(e) => {
                            props.dataItem.countriesUser = onCoun(e, props);
                            props.dataItem.invalidCountry = false;
                          }}
                          defaultValue={props.dataItem.countriesUser}
                          placeholder={
                            props.dataItem !== undefined &&
                              props.dataItem.invalidCountry
                              ? 'Campo requerido'
                              : 'Ingrese el país'
                          }
                          className={
                            props.dataItem !== undefined &&
                              props.dataItem.invalidCountry
                              ? 'required'
                              : ''
                          }
                        />
                      </td>
                    )}
                  />
                  <GridColumn
                    field="programsUser"
                    title="Programas"
                    cell={(props: any) => (
                      <td
                        className={
                          props.dataItem.isPendingChange ? 'pendingChanges' : ''
                        }
                      >
                        <MultiSelect
                          data={programas}
                          textField="programName"
                          dataItemKey="programId"
                          onChange={(e) => {
                            onChangePrograms(e, props);
                            props.dataItem.invalidProgram = false;
                          }}
                          defaultValue={props.dataItem.programsUser}
                          placeholder={
                            props.dataItem !== undefined &&
                              props.dataItem.invalidProgram
                              ? 'Campo requerido'
                              : 'Ingrese el país'
                          }
                          className={
                            props.dataItem !== undefined &&
                              props.dataItem.invalidProgram
                              ? 'required'
                              : ''
                          }
                        />
                      </td>
                    )}
                  />
                </Grid>
              </div>
            </div>
          </div>
          <div className="row justify-content-end">
            <div className="col-12 col-md-3 mt-5">
              <button className="btn-pjt" onClick={(e) => saveUsers()}>
                Guardar Usuarios
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}